import axios from 'axios';
import { clearSession } from '../utils/authUtils';
import getBrowserId from '../utils/browserId';
import clienteAxios from './Axios.jsx';

/**
 * Realiza una solicitud para autenticar al usuario.
 * @param {Object} payload - Credenciales del usuario (username y password).
 * @returns {Promise} - Promesa que se resuelve con la respuesta del servidor.
 * @throws {Error} - Error lanzado si la solicitud no se completa correctamente.
 */
export const loginService = async (payload) => {
  try {
    const browserId = getBrowserId();
    const retorno = await Promise.resolve(
      clienteAxios.post(
        '/auth/login',
        {
          username: payload.username,
          password: payload.password,
          captchaToken: payload.captchaToken,
          browser_id: browserId,
          browserId,
        },
        {
          headers: {
            'x-browser-id': browserId,
          },
        }
      )
    );
    return retorno;
  } catch (error) {
    throw new Error(error);
  }
};

/**
 * Realiza una solicitud para autenticar al usuario.
 * @param {Object} payload - Credenciales del usuario (username y password).
 * @returns {Promise} - Promesa que se resuelve con la respuesta del servidor.
 * @throws {Error} - Error lanzado si la solicitud no se completa correctamente.
 */
export const authService = async (payload) => {
  try {
    const browserId = getBrowserId();
    const response = await axios.post(
      '/auth/login',
      {
        username: payload.username,
        password: payload.password,
        captchaToken: payload.captchaToken,
        browser_id: browserId,
        browserId,
      },
      {
        baseURL: process.env.REACT_APP_API_URL,
        withCredentials: true,
        headers: {
          'x-browser-id': browserId,
        },
      }
    );

    return { success: true, ...response };
  } catch (error) {
    if (error.response) {
      return { success: false, ...error.response };
    }
    throw error;
  }
};

/**
 * Realiza una solicitud para cerrar la sesión del usuario.
 * @returns {Promise} - Promesa que se resuelve con la respuesta del servidor.
 * @throws {Error} - Error lanzado si la solicitud no se completa correctamente.
 */
export const logoutService = async () => {
  try {
    const retorno = await Promise.resolve(clienteAxios.get('/auth/logout'));
    return retorno;
  } catch (error) {
    throw new Error(error);
  }
};

/**
 * Realiza un cierre de sesión completo mediante una solicitud al endpoint de logout.
 * Limpia la sesión del usuario y redirige a la página de inicio.
 * @param {string} errorMsg - Mensaje de error opcional para establecer antes del cierre de sesión.
 */
export const completeLogoutService = async (errorMsg) => {
  try {
    await logoutService();
  } catch (error) {
    /* DO NOTHING */
  }

  // Limpia la sesión del usuario y redirige a la página de inicio
  clearSession(errorMsg);
};
